<template>
  <i-tooltip placement="top">
    <i-button outline color="info" size="md" @click="setColorMode">
      <svg viewBox="0 0 24 24" width="28" height="28" class="inkline-icon">
        <use xlink:href="@/assets/icons.svg#color-mode" x="0" y="0" width="28" height="28"></use>
      </svg>
    </i-button>
    <template #body>Toggle to {{ colorMode === 'dark' ? 'light' : 'dark' }} mode</template>
  </i-tooltip>
</template>

<script>
import { inject, ref } from 'vue'

export default {
  setup () {
    const inkline = inject('inkline', {})
    const colorMode = ref(inkline.options.colorMode)

    if (colorMode.value === 'system' && typeof window !== 'undefined') {
      colorMode.value = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
    }
    const setColorMode = () => {
      const mode = colorMode.value === 'dark' ? 'light' : 'dark'

      inkline.options.colorMode = mode
      colorMode.value = mode
    }

    return {
      colorMode,
      setColorMode
    }
  }
}
</script>

<style>
  .theme-toggle {
    cursor: pointer;
    text-transform: capitalize;
  }
</style>
